import { call, fork, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import ConnectorsClient from 'rest/ConnectorsClient';
import { errorAction } from 'components/utility/actions';
import * as actions from './actions';

const connectorsClient = new ConnectorsClient();

export function doFetchConnectors() {
	return connectorsClient.get();
}

export function *fetchConnectors(action) {
	try {
		const response = yield call(doFetchConnectors);
		yield put({ payload: response.data, type: actions.FETCH_CONNECTORS_SUCCESS });
	} catch (error) {
		yield put(errorAction(actions.FETCH_CONNECTORS_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeEvery, actions.FETCH_CONNECTORS, fetchConnectors);
}
